import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const PatientProfileCardStyles = makeStyles((theme: Theme) => ({
  patientName: {
    fontFamily: "Inter",
    fontWeight: "bold ",
    color: "#0126FF",
    fontSize: "32px",
  },
  phone: {},
  phoneIcon: {
    width: "24px !important",
    height: "24px !important",
  },
  phoneText: {
    paddingLeft: "10px",
  },
  email: {},
  emailIcon: {
    width: "24px !important",
    height: "24px !important",
  },
  emailText: {
    paddingLeft: "10px",
  },
  reason: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // overF: "hidden",
    // textOverflow: "ellipsis",
  },
  card: {
    paddingBottom: "21px",
    borderRadius: "10px",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    backgroundColor: "rgba(237, 238, 244, 1)",
  },
  pt21: {
    paddingTop: "21px",
  },
  pl40: {
    paddingLeft: "40px",
  },
  btmBorder: {
    borderBottom: "1px solid rgba(112, 112, 112, 0.4)",
  },
  cardPaddingSection: {
    padding: "0px 21px 0px 21px",
  },
  title: {
    paddingTop: "8px",
    fontSize: "20px ",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    fontWeight: "bold !important",
  },
  value: {
    paddingTop: "8px",
    fontSize: "20px",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    textTransform: "capitalize",
    minHeight: "38px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}))
